// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MenuListNew{padding:10px 0;display:flex;align-items:center;align-content:center}", ""]);
// Exports
module.exports = exports;
